exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-6b4f6649] {\n    border: 1px solid black;\n    font-size: 56px;\n}\n", ""]);

// exports
